import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { flexRow, flexRowStart } from '../../../../common/styles/flex';

interface StylesObject {
    nextVideoContainerStyle: { [key: string]: any };
    thumbnailStyle: { [key: string]: any };
    thumbnailWrapperStyle: { [key: string]: any };
}

const nextVideoContainer = {
  ...flexRow,
  alignItems: 'center',
  width: '101px',
  height: '30px',
  cursor: 'pointer',
  marginBottom: '4px',
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK_80_OPACITY,
  borderRadius: `${SITE_VARIABLES.BORDER_RADIUS.TINY} 0px 0px ${SITE_VARIABLES.BORDER_RADIUS.TINY}`,
};

const thumbnailWrapper = {
  ...flexRowStart,
  position: 'relative',
};

const thumbnail = {
  maxWidth: '52px',
  maxHeight: '30px',
  borderRadius: `${SITE_VARIABLES.BORDER_RADIUS.TINY} 0px 0px ${SITE_VARIABLES.BORDER_RADIUS.TINY}`,
};

export const getNextVideoStyleObject = (): StylesObject => ({
  nextVideoContainerStyle: {
    ...nextVideoContainer,
  },
  thumbnailWrapperStyle: {
    ...thumbnailWrapper,
  },
  thumbnailStyle: {
    ...thumbnail,
  },
});
